<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  margin: 0;
  padding:0;
  box-sizing: border-box;
}
html,body{
  width: 100%;
  height:100%;
  font-size: 12px;
}
@media screen and (min-width:1000px) {
    html,body { 
        height:100%;
        font-size: 14px;
    }
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
